import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import isNil from 'lodash.isnil';
import omitBy from 'lodash.omitby';
import {
  EricssonNETargetInfoFormData,
  EricssonNETargetInfoFIXTargetFormData,
  EricssonNETargetInfoGPRSTargetFormData,
  EricssonNETargetInfoMonitoringFormData,
  EricssonNETargetInfoMSCTargetFormData,
  EricssonNETargetInfoMCTargetFormData,
  EricssonNETargetInfoTargetFormData,
  ERICSSON_NE_TAB_TEMPORARY_ID,
  EricssonNETargetInfoGeneralFormData,
} from 'data/target/target.types';

let nextId = 0;

// eslint-disable-next-line import/prefer-default-export
export function createEricssonNETargetInfoBasedOnTemplate(
  interceptType?: string,
  netype?: string,
  template?: FormTemplate,
): Partial<EricssonNETargetInfoFormData> {
  if (template == null) {
    return {};
  }

  let formData: Partial<EricssonNETargetInfoFormData> | null = null;
  const general = getFieldValuesFromSection(
    template.general as FormTemplateSection,
  ) as EricssonNETargetInfoGeneralFormData;

  const EIMSTARGET = getFieldValuesFromSection(
    template.EIMSTARGET as FormTemplateSection,
  ) as EricssonNETargetInfoTargetFormData;

  formData = { general, EIMSTARGET };

  if (netype === 'GPRS') {
    const EIMSGPRSTRGT = getFieldValuesFromSection(
      template.EIMSGPRSTRGT as FormTemplateSection,
    ) as EricssonNETargetInfoGPRSTargetFormData;

    formData = {
      ...formData,
      EIMSGPRSTRGT,
    };
  }

  if (netype === 'MSC') {
    const EIMSMSCTRGT = getFieldValuesFromSection(
      template.EIMSMSCTRGT as FormTemplateSection,
    ) as EricssonNETargetInfoMSCTargetFormData;

    formData = {
      ...formData,
      EIMSMSCTRGT,
    };
  }

  if (netype === 'FIX') {
    const EIMSWRLNTRGT = getFieldValuesFromSection(
      template.EIMSWRLNTRGT as FormTemplateSection,
    ) as EricssonNETargetInfoFIXTargetFormData;

    formData = {
      ...formData,
      EIMSWRLNTRGT,
    };
  }

  if (netype === 'OV_SIPSERVER' || netype === 'OV_MOWLAN' || netype === 'OV_GPRS') {
    const EIMSMC = getFieldValuesFromSection(
      template.EIMSMC as FormTemplateSection,
    ) as EricssonNETargetInfoMCTargetFormData;

    formData = {
      ...formData,
      EIMSMC,
    };
  }

  if (interceptType !== 'CD' && netype !== 'HLR' && netype !== 'OV_MOWLAN' && netype !== 'OV_SIPSERVER' && netype !== 'OV_GPRS') {
    const EIMSMCNB = getTabFieldValuesFromSection(
      template.EIMSMCNB as FormTemplateSection,
      template,
      'EIMSMCNB',
    );

    formData = { ...formData, EIMSMCNB };
  }

  return omitBy(formData, isNil) as unknown as EricssonNETargetInfoFormData;
}

function getFieldValuesFromSection(
  templateSection: FormTemplateSection,
): Partial<
  EricssonNETargetInfoTargetFormData |
  EricssonNETargetInfoGPRSTargetFormData |
  EricssonNETargetInfoMonitoringFormData
> {
  return Object.entries(templateSection?.fields)
    .filter(([_fieldName, field]) => field.initial != null)
    .reduce((previousValue, [fieldName, field]) => ({
      ...previousValue,
      [fieldName]: field.initial,
    }), {});
}

function getTabFieldValuesFromSection(
  templateSection: FormTemplateSection,
  template: FormTemplate,
  templateSectionName: 'EIMSMCNB',
): (EricssonNETargetInfoMonitoringFormData)[] | undefined {

  if (templateSection == null) {
    return;
  }

  const fields = {
    ...getFieldValuesFromSection(template[templateSectionName] as FormTemplateSection),
    temporaryId: getNextTemporaryId(),
  };

  return [fields as EricssonNETargetInfoMonitoringFormData];
}

export function getNextTemporaryId(): string {
  nextId += 1;
  return `${nextId}.${ERICSSON_NE_TAB_TEMPORARY_ID}`;
}
